$ = require 'jquery'
React = require 'react'
ReactDOM = require 'react-dom'
Controller = require 'controller'
Keys = require 'data/keys'
Layout = require 'views/lib/layout'
PluginModal = require 'views/lib/plugin-modal'
SidebarState = require 'view-models/sidebar-state'
UserInput = require 'views/internal/user-input'
Util = require 'lib/util'
WindowSize = require 'lib/window-size'
_ = require 'underscore'
templates = require 'views/internal/templates'

# Modal
module.exports = Dialog = new class

  o = this

  $body = null
  $overlay = null
  $dialog = null
  $content = null
  fnOnHide = null

  shortcut: (key) ->

    switch key
      when Keys.Escape
        @hide()
        ["Esc - Hide Dialog", "Dialog"]

  init: ->

    $body = $('body')
    $overlay = $('.window-overlay')
    $dialog = $('.window')
    $content = $dialog.find('.window-wrapper')
    $content.addClass('js-tab-parent')

    @scrolltop = 0
    @isVisible = false
    @closeOnBlur = false
    @displayType = null
    @lastScroll = 0
    @hardToClose = true

    # Keeps the dialog from closing by clicking outside of it.
    # See doc-init.coffee
    @harderToClose = false

    $overlay.on 'scroll mousedown keydown', (e) =>
      @lastScroll = Date.now()

    $dialog.on 'scroll', =>
      @onScrollInner?()

    # Popover Events
    $body.on('popover-show', @maybeHide.bind(this))

    return

  maybeHide: (e, { elem }) ->
    # Close open Dialog if the popover has a trigger element
    # and the trigger element is not inside the Dialog
    # we also check if the Dialog is hard to close, this was added
    # to protect this functionality effecting Dialogs we don't want to
    # break/close by accident, such as the card back
    if @isVisible && !@hardToClose && elem? && !@contains(elem)
      @hide(null, null, false)

  scrolledSince: (ms) ->
    @lastScroll > ms

  calcPos: (maxWidth) ->
    # if the dialog is visible
    # set the left position, position off the page
    # if not visible
    # set the top and left position

    # For small window size, change width to 'auto'
    # For other window sizes, use maxWidth or reset to ''
    if WindowSize.fSmall
      width = 'auto'
    else
      width = maxWidth ? @_lastArgs.maxWidth || ''

    $dialog.css
      width: width

    if @view?.setFixedSidebarLeftPos? && Dialog.isVisible
      @view.setFixedSidebarLeftPos()

    if !Dialog.isVisible
      $dialog.show()

    return

  show: (args) ->
    @_lastArgs = args

    # It's possible that we're already showing another dialog, if so we need
    # to hide that one first so it'll let go of its shortcuts
    if @isVisible
      @hide(args.isNavigating)

    # hide / clear / reset stuff
    Layout.cancelEdits()
    PluginModal.close()
    SidebarState.hideUnpinnedSidebar()

    $body.trigger 'dialog-show'

    fnOnHide = args.hide

    if args.onScrollInner?
      @onScrollInner = args.onScrollInner

    @scrolltop = $(window).scrollTop()

    $body.addClass('window-up')

    Controller.getCurrentBoard()?.composer.save('vis', false)

    $body
    .find('.js-disable-on-dialog:not([disabled])')
    .addClass('disabled-for-dialog')
    .attr('disabled', 'disabled')

    if args.closeOnBlur?
      @closeOnBlur = args.closeOnBlur

    if args.hardToClose?
      @hardToClose = args.hardToClose

    # Set harderToClose arg or reset
    @harderToClose = args.harderToClose || false

    # special display types before adding to the DOM.
    if args.displayType?
      $dialog.addClass(args.displayType)
      @displayType = args.displayType
      @overlayClasses = _.chain(args.displayType.split(' '))
        .map((c) -> "#{c}-overlay")
        .join(' ')
        .value()
      $overlay.addClass(@overlayClasses)

    if args.opacity?
      $overlay.css('background-color', "rgba(0, 0, 0, #{args.opacity})")

    # add the close button
    $content.empty().append(templates.fill('dialog_close_button'))

    # if we've been given a maxWidth, pass it to calcPos
    if args.maxWidth? then @calcPos(args.maxWidth) else @calcPos("")

    if args.view
      @view = args.view

      $content.append(@view.el)
      @view.render()

      # NOTE: This is tricky.  If we don't explicitly call delegateEvents
      # here, then when jQuery replaced the existing content, it may have
      # removed our previous view.el from the DOM ... and if it did that
      # then all the events attached by the built-in call to delegateEvents
      # will be lost.  We restore them by calling view.delegateEvents() again
      @view.delegateEvents()
      UserInput.addHandler @view,
        scope: 'dialog_view'

    else if args.html
      @view = null
      $content.append(args.html)

    else if args.reactElement
      if !React.isValidElement args.reactElement
        throw new Error("Dialog args.reactElement has to be a react element")

      @dr = ReactDOM.render(
        args.reactElement,
        $content[0]
      )

    @isVisible = true
    @lastScroll = 0

    _.defer =>
      $dialog.css
        height: 100000
      $overlay.scrollTop(1)
      $overlay.scrollTop(0)
      $dialog.css
        height: ""

    $dialog.find('.js-autofocus:first,.focus-dummy').focus().select()

    # events
    $dialog.find('input[type=submit]').click (ev) ->
      Util.preventDefault(ev)
      return

    $dialog.find('.js-close-window').click (e) ->
      Util.stop(e)
      Dialog.hide(null, true)
      return

    UserInput.addHandler(@, {
      scope: 'dialog'
      modal: true
    })

    return

  # If isNavigating is true, then we're being hidden
  # because the user is navigating to a new page (not
  # because they clicked outside the dialog or on the
  # close button)
  hide: (isNavigating, force, closePopup = true) ->
    # this is ugly. we want the global keyup event in doc-init.coffee to come
    # through if these conditions are met. otherwise, when we hit escape, we
    # close the card while editing fields.
    # if isNavigating then we should not prevent dialog from closing
    if (!@isVisible || Layout.isEditing() || $('.new-comment').hasClass('focus')) && (!force && !isNavigating)
      return

    @_lastArgs = null

    fnOnHide?(isNavigating)
    fnOnHide = null

    # remove special classes
    $overlay.removeClass(@overlayClasses)
    $dialog.removeClass(@displayType)
    @displayType = null

    # reset opacity
    $overlay.css('background-color', '')

    if @view?
      UserInput.removeHandler(@view)

      @view.remove()
      @view = null

    if @dr?
      ReactDOM.unmountComponentAtNode($content[0])
      @dr = null


    UserInput.removeHandler(@)

    $dialog.hide()

    $body.removeClass('window-up')

    _.defer =>
      $(window).scrollTop(@scrolltop)
      @scrolltop = 0

    @isVisible = false

    # in CardDetailView::fixSidebar
    $overlay.off('scroll.fixSidebar')

    $('.disabled-for-dialog').removeAttr('disabled')

    $body.trigger 'dialog-hide', { closePopup }

    @clear()

    return

  clear: ->
    $content.width('')
    $content.empty()
    return

  contains: (elem) ->
    $dialog.find(elem).length > 0



// WEBPACK FOOTER //
// ./app/scripts/views/lib/dialog.coffee